<template>
    <Accordion>
        <template v-slot:title>{{ translate("admin.manage_organizers.differences") }}</template>
        <template v-slot:content>
            <div class="content">
                <ul>
                    <li>{{ translate("admin.manage_organizers.full_organizer_desc") }}</li>
                    <li>
                        {{ translate("admin.manage_organizers.technician_desc") }}
                        <ul>
                            <li>{{ translate("admin.manage_organizers.technician_desc_1") }}</li>
                            <li>{{ translate("admin.manage_organizers.technician_desc_2") }}</li>
                            <li>{{ translate("admin.manage_organizers.technician_desc_3") }}</li>
                            <li>{{ translate("admin.manage_organizers.technician_desc_4") }}</li>
                        </ul>
                    </li>
                    <li>
                        {{
                            translate(
                                scope === "federation"
                                    ? "admin.manage_organizers.staff_desc_federation"
                                    : "admin.manage_organizers.staff_desc_event",
                            )
                        }}
                        <ul>
                            <li>{{ translate("admin.manage_organizers.staff_desc_referee") }}</li>
                            <li>{{ translate("admin.manage_organizers.staff_desc_verification_desk") }}</li>
                            <li>{{ translate("admin.manage_organizers.staff_desc_results_decoration") }}</li>
                            <li>{{ translate("admin.manage_organizers.staff_desc_announcer") }}</li>
                        </ul>
                    </li>
                </ul>
            </div>
        </template>
    </Accordion>
</template>

<script setup lang="ts">
    import Accordion from "./Accordion.vue";
    import { translate } from "./translations";

    defineProps<{ scope: "event" | "federation" }>();
</script>
